import { computed, ref, watch } from 'vue'
import { PankuzuType } from '../CCPankuzu'
import { RouteLocationNormalizedLoaded } from 'vue-router'

export function getPankuzuItemFromRoute(route: RouteLocationNormalizedLoaded): PankuzuType[] {
  return (route?.meta?.items as PankuzuType[]) ?? []
}
